import { Component } from '@angular/core';

@Component({
  selector: 'app-register-cmp',
  templateUrl: './register.component.html',
})
export class RegisterComponent {}
